export default "__VITE_ASSET__B0Bi4vWH__"